//bondcert
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
export const bondcertApi = createApi({

    reducerPath: "bondcertApi",
    baseQuery,
    tagTypes: ["bondcert"],
    endpoints: (builder) => ({
        createBondcert: builder.mutation({
            query: ({ id, ...data }) => ({
              url: `import/bondCert/${id}`,
              method: "PUT",
              body: { importBondCert: data },
              headers: {
                "X-Request-Id": Math.random().toString(36).substring(2),
              },
            }),
            invalidatesTags: ["bondcert"],
          }),
          updateBondcert: builder.mutation({
            query: ({ id, subId, ...data }) => {
      
              return {
                url: `import/bondCert/${id}/${subId}`,
                method: "PUT",
                body: { importBondCert: data },
                headers: {
                  "X-Request-Id": Math.random().toString(36).substring(2),
                },
              };
            },
            invalidatesTags: ["bondcert"],
          }),

          deleteBondcert: builder.mutation({
            query: ({ id }) => ({
              url: `import/bondCert/${id}`,
              method: "DELETE",
              headers: {
                "X-Request-Id": Math.random().toString(36).substring(2),
              },
            }),
            invalidatesTags: ["bondcert"],
          }),
          getBondCertId: builder.query({
            query: ({id}) => `import/bondCert/${id}`,
            transformResponse: (response) => 
              {
                const data= response?.data ?? [];
                const normalized = Array.isArray(data) ? data : [data];
                return normalized.map((item,index) => ({
                  ...item,
                  SrNo:index+1,
                  id: item.importBondCertId, //  use backend's exportEntityId
                }));
    
              },
            providesTags: ["bondcert"],
          }),





        }),
    });
    export const {
        useCreateBondcertMutation,
        useUpdateBondcertMutation,
        useDeleteBondcertMutation,
        useLazyGetBondCertIdQuery,
        
       
      } = bondcertApi;